import React, { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { PaddingType } from '../../puck/reusable-props/padding';
import Toggle from '../../../components/common/toggleButton';
import { getNumberPattern } from '../../utils/helper';
import InputField from '../../../components/common/input-field';

interface IProps {
  value: PaddingType;
  onChange: (_value: PaddingType) => void;
  title?: string;
  extraFields?: boolean;
}

const PaddingComponent: React.FC<IProps> = ({
  value,
  onChange,
  title = 'Customize Padding',
  extraFields = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <div
        className=" flex justify-between font-bold cursor-pointer py-2 bg-slate-100 rounded-md pagebuilder-theme"
        onClick={toggleAccordion}>
        <h3>{title}</h3>
        {!isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
      </div>
      {isOpen && (
        <div className="border border-gray-300 rounded p-2 w-full flex flex-col gap-2 ">
          <Toggle<PaddingType>
            value={value}
            onChange={newValue => onChange({ ...value, ...newValue })}
            heading={{ label: 'Device', value: 'device' }}
            options={[
              { label: 'Desktop', value: 'desktop' },
              { label: 'Tablet', value: 'tablet' },
              { label: 'Mobile', value: 'mobile' },
            ]}
            propName="deviceType"
          />
          {extraFields && (
            <Toggle<PaddingType>
              value={value}
              onChange={newValue => onChange({ ...value, ...newValue })}
              options={[
                { label: 'XL', value: 'doubleXL' },
                { label: '2XL', value: 'tripleXL' },
              ]}
              hideHeading={true}
              propName="deviceType"
            />
          )}
          <div className="grid grid-cols-[1fr_1fr] gap-2.5 border-t-1">
            {' '}
            <InputField
              value={value?.paddingTop?.[value?.deviceType]}
              onChange={e => {
                const newValue = getNumberPattern(e);
                if (newValue) {
                  onChange({
                    ...value,
                    paddingTop: {
                      ...value.paddingTop,
                      [value.deviceType]: newValue,
                    },
                  });
                }
              }}
              className="h-[42px]"
              label="Top"
            />
            <InputField
              value={value?.paddingBottom?.[value?.deviceType]}
              onChange={e => {
                const newValue = getNumberPattern(e);
                if (newValue) {
                  onChange({
                    ...value,
                    paddingBottom: {
                      ...value.paddingBottom,
                      [value.deviceType]: newValue,
                    },
                  });
                }
              }}
              className="h-[42px]"
              label="Bottom"
            />
            <InputField
              value={value?.paddingLeft?.[value?.deviceType]}
              onChange={e => {
                const newValue = getNumberPattern(e);
                if (newValue) {
                  onChange({
                    ...value,
                    paddingLeft: {
                      ...value.paddingLeft,
                      [value.deviceType]: newValue,
                    },
                  });
                }
              }}
              className="h-[42px]"
              label="Left"
            />
            <InputField
              value={value?.paddingRight?.[value?.deviceType]}
              onChange={e => {
                const newValue = getNumberPattern(e);
                if (newValue) {
                  onChange({
                    ...value,
                    paddingRight: {
                      ...value.paddingRight,
                      [value.deviceType]: newValue,
                    },
                  });
                }
              }}
              className="h-[42px]"
              label="Right"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default PaddingComponent;
